import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class preCommonDocumentsInfo {
      StudentDocumentID : number;
      StudentID : number;
      DocumentID : number;
      DocumentApprovedFlag : string;
      DocumentRemark : string;
      DocumentApprovedByID : number;
      DeleteFlag  : string;
      CreatedLoginID : number;
      UpdatedLoginID : number;
      Documents : Documents[];
}
export class Documents {
  StudentDocumentID : number;
  StudentID : number;
  DocumentID : number;
  DocumentName : string;
  checkedValue : string;
  chk:boolean;
  DocumentApprovedFlag : string;
  DocumentRemark : string;
  DocumentApprovedByID : number;
  DocumentApprovedDate  : string;
  DeleteFlag  : string;
  CreatedLoginID : number;
  UpdatedLoginID : number;
  DocumentPath:string;
  CompOptFlag:string;
}
export class EducationalStream {
  EducationalStreamID:number;
  EducationalStreamName:string;
  AddInfo:string;
}
export class UsertDetailsStatus
{
     StudentID:number;
     StatusID :number; 
     StatusName :string;  
     StatusFlag :string; 
     profilePicPath:string;
     ProfileLockStatusFlag:string;
     chk:boolean;
}
@Injectable( {  
  providedIn: 'root'  
})
@Component({
  providers: [DataAccessService]
})

export class CommondocumentsService {

  constructor(private dataService: DataAccessService) {
   
  }
  public save(data) {
    this.dataService.setControllerName = '/PreStudentDocuments/';
    this.dataService.setMethodName = 'PostInsertPreStudentDocuments'; // setting method name from API controller.
    return this.dataService.add<preCommonDocumentsInfo[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/PreStudentDocuments/';
    this.dataService.setMethodName = 'PostInsertPreStudentDocuments'; // setting method name from API controller.
    return this.dataService.add<preCommonDocumentsInfo[]>(data)
  }
  public GetContactinfo(StudentID) {
    this.dataService.setControllerName = '/PreStudentAddressInfo/';
    this.dataService.setMethodName = 'GetPreStudentAddressInfoList?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<preCommonDocumentsInfo[]>()
  } 
  public GetEducationalStream() {
    this.dataService.setControllerName = '/BasicEducationalStream/';
    this.dataService.setMethodName = 'GetBasicEducationalStreamList?EducationalStreamID=0'; // setting method name from API controller.
    return this.dataService.getAll<EducationalStream[]>()
  }
  public GetPreStudentDocumentsList(StudentID) {
    this.dataService.setControllerName = '/PreStudentDocuments/';
    this.dataService.setMethodName = 'GetPreStudentDocumentsList?StudentID=' + StudentID + ''; // setting method name from API controller.
    return this.dataService.getAll<Documents[]>()
  }
  public GetCompDocumentsForAdmission(StudentID) {
    this.dataService.setControllerName = '/PreStudentDocuments/';
    this.dataService.setMethodName = 'GetCompDocumentsForAdmissionNEW?StudentID=' + StudentID + ''; // setting method name from API controller.
    return this.dataService.getAll<Documents[]>()
  }
  public GetProfileLockStatusForAdmissionForm(StudentID) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetProfileLockStatusForAdmissionForm?StudentID='+ StudentID; // setting method name from API controller.
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  public getupdateprofilelock(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'Getupdateprofilelock?StudentID='+ StudentID ; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  public getupdateCommonDocFlag(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'getupdateCommonDocFlag?StudentID='+ StudentID ; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  /* addEducationalDetails(data: preSocialReservationInfo) {
    data.StudentOtherInfoID = educationaldetails.length + 1;
    educationaldetails.push(data);
  } */
  saveEducationalDetails(data: preCommonDocumentsInfo) {

  }
  deleteEducationalDetails(data: preCommonDocumentsInfo) {
    this.dataService.setControllerName = '/PreStudentDocuments/';
    this.dataService.setMethodName = 'PostDeletePreStudentDocuments' ; // setting method name from API controller
    return this.dataService.delete<UsertDetailsStatus>(data);
  }

  public deleteUploadedDocument(data:any){
    this.dataService.setControllerName = '/PreStudentDocuments/';
    this.dataService.setMethodName = 'PostDeletePreStudentDocuments' ; // setting method name from API controller
    return this.dataService.delete<UsertDetailsStatus>(data);
  }

  // public GetDocumentsForNameChange() {debugger
  //   this.dataService.setControllerName = '/PreStudentDocuments/';
  //   //this.dataService.setMethodName = 'GetDocumentsForNameChange?DocumentID='+DocumentID;
  //   this.dataService.setMethodName = 'GetDocumentsForNameChange?DocumentID=0';  
  //   // setting method name from API controller.
  //   return this.dataService.getAll<Documents[]>()
  // }

  
}
